import { inject, Injectable } from '@angular/core';
import { LoggableAPI } from '../models/protocols/loggable-api';
import { Observable, throwError } from 'rxjs';
import { ApiClient } from './api-client';
import { PortalTypeIdEnum } from '../models/enum/shared/portal-type-id.enum';
import { Endpoints } from './endpoints';
import { catchError } from 'rxjs/operators';
import { EndUserLicenceAgreement } from '../models/shared/end-user-licence-agreement';
import { CustomError } from '../models/shared/custom-error';

@Injectable({
  providedIn: 'root'
})
export class EulaAPI implements LoggableAPI {
  private apiClient = inject(ApiClient);

  public serviceName = 'EulaAPI';

  public getEulaByPortalTypeId(portalTypeId: PortalTypeIdEnum): Observable<EndUserLicenceAgreement> {
    const url = Endpoints.getEula(portalTypeId);
    return this.apiClient.getObj(EndUserLicenceAgreement, url).pipe(
      catchError(e => {
        const err = new CustomError(e, this.serviceName);
        return throwError(() => err);
      })
    );
  }
}
